import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/home/index.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  // ===== 后台管理 =====
  {
    path: '/admin',
    component: () => import('@/views/admin/layout.vue'),
    meta: { requiresAuth: true },
    children: [
      { path: '', name: 'adminDashboard', component: () => import('@/views/admin/dashboard.vue') },
      { path: 'banners', name: 'adminBanners', component: () => import('@/views/admin/banners.vue') },
      { path: 'articles', name: 'adminArticles', component: () => import('@/views/admin/articles.vue') },
      { path: 'articles/edit/:id?', name: 'adminArticleEdit', component: () => import('@/views/admin/articleEdit.vue') },
      { path: 'categories', name: 'adminCategories', component: () => import('@/views/admin/categories.vue') },
      { path: 'notices', name: 'adminNotices', component: () => import('@/views/admin/notices.vue') },
      { path: 'videos', name: 'adminVideos', component: () => import('@/views/admin/videos.vue') },
      { path: 'experts', name: 'adminExperts', component: () => import('@/views/admin/experts.vue') },
      { path: 'locations', name: 'adminLocations', component: () => import('@/views/admin/locations.vue') },
      { path: 'pages', name: 'adminPages', component: () => import('@/views/admin/pages.vue') },
      { path: 'navigations', name: 'adminNavigations', component: () => import('@/views/admin/navigations.vue') },
      { path: 'config', name: 'adminConfig', component: () => import('@/views/admin/config.vue') },
      { path: 'channel-headers', name: 'adminChannelHeaders', component: () => import('@/views/admin/channelHeaders.vue') },
    ]
  },
  { path: '/admin/login', name: 'adminLogin', component: () => import('@/views/admin/login.vue') },

  // ===== 前台页面 =====
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '@/views/about/aboutus.vue')
  },
  {
    path: '/appDownload',
    name: 'appDownload',
    component: () => import(/* webpackChunkName: "appDownload" */ '@/views/app/download.vue')
  },
  {
    path: '/toMobile',
    name: 'toMobile',
    component: () => import(/* webpackChunkName: "toMobile" */ '@/views/app/mobile.vue')
  },
  {
    path: '/article',
    name: 'article',
    component: () => import(/* webpackChunkName: "article" */ '@/views/article/index.vue')
  },
  {
    path: '/articleList',
    name: 'articleList',
    component: () => import(/* webpackChunkName: "articleList" */ '@/views/article/list.vue') 
  },
  {
    path: '/chineseMedicine',
    name: 'chineseMedicine',
    component: () => import(/* webpackChunkName: "chineseMedicine" */ '@/views/chineseMedicine/index.vue')
  },
  {
    path: '/videoCourse',
    name: 'videoCourse',
    component: () => import(/* webpackChunkName: "videoCourse" */ '@/views/videoCourse/index.vue')
  },
  // ===== 通用单页路由 =====
  {
    path: '/page/:slug',
    name: 'page',
    component: () => import(/* webpackChunkName: "page" */ '@/views/page/index.vue')
  },
  // ===== 产品/课程 =====
  {
    path: '/productList',
    name: 'productList',
    component: () => import(/* webpackChunkName: "productList" */ '@/views/product/list.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import(/* webpackChunkName: "product" */ '@/views/product/detail.vue')
  },
  // ===== 图书资料 =====
  {
    path: '/bookList',
    name: 'bookList',
    component: () => import(/* webpackChunkName: "bookList" */ '@/views/book/list.vue')
  },
  {
    path: '/book',
    name: 'book',
    component: () => import(/* webpackChunkName: "book" */ '@/views/book/detail.vue')
  },
  // ===== 考试频道旧路径重定向（向后兼容）=====
  { path: '/nurseQualification', redirect: '/examChannel/nurse-qualification' },
  { path: '/primaryNurse', redirect: '/examChannel/health-title' },
  { path: '/supervisorNurse', redirect: '/examChannel/health-title' },
  { path: '/clinicalDoctor', redirect: '/examChannel/clinical-doctor' },
  { path: '/clinicalAssistantDoctor', redirect: '/examChannel/clinical-assistant-doctor' },
  { path: '/doctorOfChinese', redirect: '/examChannel/doctor-of-chinese' },
  { path: '/doctorOfChineseAndHerbal', redirect: '/examChannel/doctor-of-chinese-and-herbal' },
  { path: '/pharmacist', redirect: '/examChannel/pharmacist' },
  { path: '/threeBaseExam', redirect: '/examChannel/three-base-exam' },
  { path: '/juniorPharmacist', redirect: '/examChannel/health-title' },
  { path: '/basicPharmacist', redirect: '/examChannel/health-title' },
  { path: '/chiefPharmacist', redirect: '/examChannel/health-title' },
  { path: '/juniorTechnician', redirect: '/examChannel/health-title' },
  { path: '/inspectionTechnician', redirect: '/examChannel/health-title' },
  { path: '/supervisorTechnician', redirect: '/examChannel/health-title' },
  { path: '/juniorChinesePharmacist', redirect: '/examChannel/health-title' },
  { path: '/supervisorChinesePharmacist', redirect: '/examChannel/health-title' },
  { path: '/seniorProfessional', redirect: '/examChannel/health-title' },
  { path: '/generalPractitioner', redirect: '/examChannel/general-practitioner' },
  { path: '/internalPractitioner', redirect: '/examChannel/health-title' },
  { path: '/externalPractitioner', redirect: '/examChannel/health-title' },
  { path: '/obstetricPractitioner', redirect: '/examChannel/health-title' },
  { path: '/pediatricPractitioner', redirect: '/examChannel/health-title' },
  { path: '/internalChinesePractitioner', redirect: '/examChannel/health-title' },

  {
    path: '/examChannel',
    name: 'examChannel',
    component: () => import(/* webpackChunkName: "examChannel" */ '@/views/examChannel/index.vue'),
    children: [
      {
        path: '',
        name: 'healthTitle',
        component: () => import(/* webpackChunkName: "healthTitle" */ '@/views/examChannel/healthTitle.vue')
      },
      {
        path: ':slug',
        component: () => import(/* webpackChunkName: "channelPage" */ '@/views/examChannel/channelPage.vue')
      },
      {
        path: '/trainingMain',
        name: 'trainingMain',
        component: () => import(/* webpackChunkName: "trainingMain" */ '@/views/examChannel/trainingMain.vue')
      },
      {
        path: '/trainingList',
        name: 'trainingList',
        component: () => import(/* webpackChunkName: "trainingList" */ '@/views/examChannel/trainingList.vue')
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
